import { render } from "./TaskFieldList.vue?vue&type=template&id=3b751cdd&scoped=true&ts=true"
import script from "./TaskFieldList.vue?vue&type=script&lang=ts"
export * from "./TaskFieldList.vue?vue&type=script&lang=ts"

import "./TaskFieldList.vue?vue&type=style&index=0&id=3b751cdd&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b751cdd"]])

export default __exports__